import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from '../../../component-lib/components/accordion/accordion.module';
import ButtonModule from '../../../component-lib/components/button/button-module';
import CardModule from '../../../component-lib/components/card/card.module';
import CurrencyModule from '../../../component-lib/components/currency/currency.module';
import { ModalModule } from '../../../component-lib/components/modal/modal.module';
import { ChooseChargingSpeedModule } from './charging-station-flow/steps/charging-speed/choose-charging-speed.module';
import { ChargingStationPlacementModule } from './charging-station-flow/steps/charging-station-placement/charging-station-placement.module';
import { NumberOfChargingStationsModule } from './charging-station-flow/steps/number-of-charging-stations/number-of-charging-stations.module';
import { SmartChargingStationModule } from './charging-station-flow/steps/smart-charging-station/smart-charging-station.module';
import { ChargingStationFlowComponent } from './charging-station-flow/charging-station-flow.component';
import { ChargingStationInputComponent } from './input.component';
import { ChargingStationInputService } from './input.service';

@NgModule({
  declarations: [ChargingStationInputComponent, ChargingStationFlowComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    ModalModule,
    CurrencyModule,
    CardModule,
    AccordionModule,
    NumberOfChargingStationsModule,
    ChooseChargingSpeedModule,
    SmartChargingStationModule,
    ChargingStationPlacementModule,
  ],
  exports: [ChargingStationInputComponent, ChargingStationFlowComponent],
  providers: [ChargingStationInputService],
})
export class ChargingStationInputModule {}
